import * as React from 'react';

const LineSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="line_svg__eds-icon--line_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="line_svg__eds-icon--line_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.4 2.6c-.8-.8-2-.8-2.8 0-.7.7-.8 1.7-.3 2.4L5 18.3c-.8-.5-1.8-.4-2.4.3-.8.8-.8 2 0 2.8s2 .8 2.8 0c.7-.7.8-1.7.3-2.4L19 5.7c.8.5 1.8.4 2.4-.3.8-.8.8-2 0-2.8M4.7 20.7c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4m16-16c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4"
        />
    </svg>
);

LineSvg.displayName = 'LineSvg';
export default LineSvg;
